import { render } from "./SiteHead.vue?vue&type=template&id=15aee0f0&scoped=true"
import script from "./SiteHead.vue?vue&type=script&lang=js"
export * from "./SiteHead.vue?vue&type=script&lang=js"

import "./SiteHead.vue?vue&type=style&index=0&id=15aee0f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aee0f0"]])

export default __exports__